export const DATA_CONNECTOR_LOAD_COLLECTIONS_BEGIN = 'DATA_CONNECTOR_LOAD_COLLECTIONS_BEGIN';
export const DATA_CONNECTOR_LOAD_COLLECTIONS_SUCCESS = 'DATA_CONNECTOR_LOAD_COLLECTIONS_SUCCESS';
export const DATA_CONNECTOR_LOAD_COLLECTIONS_FAILURE = 'DATA_CONNECTOR_LOAD_COLLECTIONS_FAILURE';
export const DATA_CONNECTOR_LOAD_COLLECTIONS_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_COLLECTIONS_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_DATA_CONNECTOR_BEGIN = 'DATA_CONNECTOR_LOAD_DATA_CONNECTOR_BEGIN';
export const DATA_CONNECTOR_LOAD_DATA_CONNECTOR_SUCCESS =
  'DATA_CONNECTOR_LOAD_DATA_CONNECTOR_SUCCESS';
export const DATA_CONNECTOR_LOAD_DATA_CONNECTOR_FAILURE =
  'DATA_CONNECTOR_LOAD_DATA_CONNECTOR_FAILURE';
export const DATA_CONNECTOR_LOAD_DATA_CONNECTOR_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_DATA_CONNECTOR_DISMISS_ERROR';
export const DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_BEGIN =
  'DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_BEGIN';
export const DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_SUCCESS =
  'DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_SUCCESS';
export const DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_FAILURE =
  'DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_FAILURE';
export const DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_DISMISS_ERROR =
  'DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_DISMISS_ERROR';
export const DATA_CONNECTOR_REFRESH_SOURCE_DATA_BEGIN = 'DATA_CONNECTOR_REFRESH_SOURCE_DATA_BEGIN';
export const DATA_CONNECTOR_REFRESH_SOURCE_DATA_SUCCESS =
  'DATA_CONNECTOR_REFRESH_SOURCE_DATA_SUCCESS';
export const DATA_CONNECTOR_REFRESH_SOURCE_DATA_FAILURE =
  'DATA_CONNECTOR_REFRESH_SOURCE_DATA_FAILURE';
export const DATA_CONNECTOR_REFRESH_SOURCE_DATA_DISMISS_ERROR =
  'DATA_CONNECTOR_REFRESH_SOURCE_DATA_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_AIRTABLE_CONNECTORS_BEGIN =
  'DATA_CONNECTOR_LOAD_AIRTABLE_CONNECTORS_BEGIN';
export const DATA_CONNECTOR_LOAD_AIRTABLE_CONNECTORS_SUCCESS =
  'DATA_CONNECTOR_LOAD_AIRTABLE_CONNECTORS_SUCCESS';
export const DATA_CONNECTOR_LOAD_AIRTABLE_CONNECTORS_FAILURE =
  'DATA_CONNECTOR_LOAD_AIRTABLE_CONNECTORS_FAILURE';
export const DATA_CONNECTOR_LOAD_AIRTABLE_CONNECTORS_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_AIRTABLE_CONNECTORS_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_NOTION_CONNECTORS_BEGIN =
  'DATA_CONNECTOR_LOAD_NOTION_CONNECTORS_BEGIN';
export const DATA_CONNECTOR_LOAD_NOTION_CONNECTORS_SUCCESS =
  'DATA_CONNECTOR_LOAD_NOTION_CONNECTORS_SUCCESS';
export const DATA_CONNECTOR_LOAD_NOTION_CONNECTORS_FAILURE =
  'DATA_CONNECTOR_LOAD_NOTION_CONNECTORS_FAILURE';
export const DATA_CONNECTOR_LOAD_NOTION_CONNECTORS_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_NOTION_CONNECTORS_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_DATA_EDIT_BEGIN = 'DATA_CONNECTOR_GET_DATA_EDIT_BEGIN';
export const DATA_CONNECTOR_GET_DATA_EDIT_SUCCESS = 'DATA_CONNECTOR_GET_DATA_EDIT_SUCCESS';
export const DATA_CONNECTOR_GET_DATA_EDIT_FAILURE = 'DATA_CONNECTOR_GET_DATA_EDIT_FAILURE';
export const DATA_CONNECTOR_GET_DATA_EDIT_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_DATA_EDIT_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_BEGIN =
  'DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_BEGIN';
export const DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_SUCCESS =
  'DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_SUCCESS';
export const DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_FAILURE =
  'DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_FAILURE';
export const DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_DISMISS_ERROR';
export const DATA_CONNECTOR_XANO_GET_TABLES_BEGIN = 'DATA_CONNECTOR_XANO_GET_TABLES_BEGIN';
export const DATA_CONNECTOR_XANO_GET_TABLES_SUCCESS = 'DATA_CONNECTOR_XANO_GET_TABLES_SUCCESS';
export const DATA_CONNECTOR_XANO_GET_TABLES_FAILURE = 'DATA_CONNECTOR_XANO_GET_TABLES_FAILURE';
export const DATA_CONNECTOR_XANO_GET_TABLES_DISMISS_ERROR =
  'DATA_CONNECTOR_XANO_GET_TABLES_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_BEGIN =
  'DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_BEGIN';
export const DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_SUCCESS =
  'DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_SUCCESS';
export const DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_FAILURE =
  'DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_FAILURE';
export const DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_COLLECTIONS_BY_APPWRITE_BEGIN =
  'DATA_CONNECTOR_LOAD_COLLECTIONS_BY_APPWRITE_BEGIN';
export const DATA_CONNECTOR_LOAD_COLLECTIONS_BY_APPWRITE_SUCCESS =
  'DATA_CONNECTOR_LOAD_COLLECTIONS_BY_APPWRITE_SUCCESS';
export const DATA_CONNECTOR_LOAD_COLLECTIONS_BY_APPWRITE_FAILURE =
  'DATA_CONNECTOR_LOAD_COLLECTIONS_BY_APPWRITE_FAILURE';
export const DATA_CONNECTOR_LOAD_COLLECTIONS_BY_APPWRITE_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_COLLECTIONS_BY_APPWRITE_DISMISS_ERROR';
export const DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_BEGIN =
  'DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_BEGIN';
export const DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_SUCCESS =
  'DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_SUCCESS';
export const DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_FAILURE =
  'DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_FAILURE';
export const DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_DISMISS_ERROR =
  'DATA_CONNECTOR_COLLECTION_LIST_EXTERNALDBS_DISMISS_ERROR';
export const DATA_CONNECTOR_GETXANO_SCHEMA_BEGIN = 'DATA_CONNECTOR_GETXANO_SCHEMA_BEGIN';
export const DATA_CONNECTOR_GETXANO_SCHEMA_SUCCESS = 'DATA_CONNECTOR_GETXANO_SCHEMA_SUCCESS';
export const DATA_CONNECTOR_GETXANO_SCHEMA_FAILURE = 'DATA_CONNECTOR_GETXANO_SCHEMA_FAILURE';
export const DATA_CONNECTOR_GETXANO_SCHEMA_DISMISS_ERROR =
  'DATA_CONNECTOR_GETXANO_SCHEMA_DISMISS_ERROR';
export const DATA_CONNECTOR_XANO_UPDATE_COLLECTION_BEGIN =
  'DATA_CONNECTOR_XANO_UPDATE_COLLECTION_BEGIN';
export const DATA_CONNECTOR_XANO_UPDATE_COLLECTION_SUCCESS =
  'DATA_CONNECTOR_XANO_UPDATE_COLLECTION_SUCCESS';
export const DATA_CONNECTOR_XANO_UPDATE_COLLECTION_FAILURE =
  'DATA_CONNECTOR_XANO_UPDATE_COLLECTION_FAILURE';
export const DATA_CONNECTOR_XANO_UPDATE_COLLECTION_DISMISS_ERROR =
  'DATA_CONNECTOR_XANO_UPDATE_COLLECTION_DISMISS_ERROR';
export const DATA_CONNECTOR_XANO_DATA_BASE_TABLE_BEGIN =
  'DATA_CONNECTOR_XANO_DATA_BASE_TABLE_BEGIN';
export const DATA_CONNECTOR_XANO_DATA_BASE_TABLE_SUCCESS =
  'DATA_CONNECTOR_XANO_DATA_BASE_TABLE_SUCCESS';
export const DATA_CONNECTOR_XANO_DATA_BASE_TABLE_FAILURE =
  'DATA_CONNECTOR_XANO_DATA_BASE_TABLE_FAILURE';
export const DATA_CONNECTOR_XANO_DATA_BASE_TABLE_DISMISS_ERROR =
  'DATA_CONNECTOR_XANO_DATA_BASE_TABLE_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_XANO_TABLE_BEGIN = 'DATA_CONNECTOR_GET_XANO_TABLE_BEGIN';
export const DATA_CONNECTOR_GET_XANO_TABLE_SUCCESS = 'DATA_CONNECTOR_GET_XANO_TABLE_SUCCESS';
export const DATA_CONNECTOR_GET_XANO_TABLE_FAILURE = 'DATA_CONNECTOR_GET_XANO_TABLE_FAILURE';
export const DATA_CONNECTOR_GET_XANO_TABLE_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_XANO_TABLE_DISMISS_ERROR';
export const DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_BEGIN =
  'DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_SUCCESS =
  'DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_FAILURE =
  'DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR =
  'DATA_CONNECTOR_SAVE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_STORED_XANO_DATA_BEGIN =
  'DATA_CONNECTOR_GET_STORED_XANO_DATA_BEGIN';
export const DATA_CONNECTOR_GET_STORED_XANO_DATA_SUCCESS =
  'DATA_CONNECTOR_GET_STORED_XANO_DATA_SUCCESS';
export const DATA_CONNECTOR_GET_STORED_XANO_DATA_FAILURE =
  'DATA_CONNECTOR_GET_STORED_XANO_DATA_FAILURE';
export const DATA_CONNECTOR_GET_STORED_XANO_DATA_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_STORED_XANO_DATA_DISMISS_ERROR';
export const DATA_CONNECTOR_XANO_SCHEMA_BEGIN = 'DATA_CONNECTOR_XANO_SCHEMA_BEGIN';
export const DATA_CONNECTOR_XANO_SCHEMA_SUCCESS = 'DATA_CONNECTOR_XANO_SCHEMA_SUCCESS';
export const DATA_CONNECTOR_XANO_SCHEMA_FAILURE = 'DATA_CONNECTOR_XANO_SCHEMA_FAILURE';
export const DATA_CONNECTOR_XANO_SCHEMA_DISMISS_ERROR = 'DATA_CONNECTOR_XANO_SCHEMA_DISMISS_ERROR';
export const DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_BEGIN =
  'DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_BEGIN';
export const DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_SUCCESS =
  'DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_SUCCESS';
export const DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_FAILURE =
  'DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_FAILURE';
export const DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_DISMISS_ERROR =
  'DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_DISMISS_ERROR';
export const DATA_CONNECTOR_SAVE_XANO_FIELDS_BEGIN = 'DATA_CONNECTOR_SAVE_XANO_FIELDS_BEGIN';
export const DATA_CONNECTOR_SAVE_XANO_FIELDS_SUCCESS = 'DATA_CONNECTOR_SAVE_XANO_FIELDS_SUCCESS';
export const DATA_CONNECTOR_SAVE_XANO_FIELDS_FAILURE = 'DATA_CONNECTOR_SAVE_XANO_FIELDS_FAILURE';
export const DATA_CONNECTOR_SAVE_XANO_FIELDS_DISMISS_ERROR =
  'DATA_CONNECTOR_SAVE_XANO_FIELDS_DISMISS_ERROR';

export const DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_BEGIN =
  'DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_BEGIN';
export const DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_SUCCESS =
  'DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_SUCCESS';
export const DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_FAILURE =
  'DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_FAILURE';
export const DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_DISMISS_ERROR';
export const DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_BEGIN =
  'DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_BEGIN';
export const DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_SUCCESS =
  'DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_SUCCESS';
export const DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_FAILURE =
  'DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_FAILURE';
export const DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_DISMISS_ERROR =
  'DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_DISMISS_ERROR';

export const DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_BEGIN =
  'DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_BEGIN';
export const DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_SUCCESS =
  'DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_SUCCESS';
export const DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_FAILURE =
  'DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_FAILURE';
export const DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_DATABASES_FOR_APPWRITE_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_BEGIN =
  'DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_BEGIN';
export const DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_SUCCESS =
  'DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_SUCCESS';
export const DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_FAILURE =
  'DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_FAILURE';
export const DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_COLLECTIONS_BY_APPWRITE_DISMISS_ERROR';
export const DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN =
  'DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN';
export const DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS =
  'DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS';
export const DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE =
  'DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE';
export const DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR =
  'DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_BEGIN =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_BEGIN';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_SUCCESS =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_SUCCESS';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FAILURE =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FAILURE';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR';

export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_BEGIN =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_BEGIN';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_SUCCESS =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_SUCCESS';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_FAILURE =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_FAILURE';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_DISMISS_ERROR =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_DISMISS_ERROR';
export const DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_BEGIN =
  'DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_BEGIN';
export const DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_SUCCESS =
  'DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_SUCCESS';
export const DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_FAILURE =
  'DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_FAILURE';
export const DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_DISMISS_ERROR =
  'DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_DISMISS_ERROR';

export const DATA_CONNECTOR_UPDATE_FIELDS_IN_EXTERNAL_DB_BEGIN =
  'DATA_CONNECTOR_UPDATE_FIELDS_IN_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_UPDATE_FIELDS_IN_EXTERNAL_DB_SUCCESS =
  'DATA_CONNECTOR_UPDATE_FIELDS_IN_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_UPDATE_FIELDS_IN_EXTERNAL_DB_FAILURE =
  'DATA_CONNECTOR_UPDATE_FIELDS_IN_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_UPDATE_FIELDS_IN_EXTERNAL_DB_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_FIELDS_IN_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_SUPABASE_DATA_BEGIN = 'DATA_CONNECTOR_GET_SUPABASE_DATA_BEGIN';
export const DATA_CONNECTOR_GET_SUPABASE_DATA_SUCCESS = 'DATA_CONNECTOR_GET_SUPABASE_DATA_SUCCESS';
export const DATA_CONNECTOR_GET_SUPABASE_DATA_FAILURE = 'DATA_CONNECTOR_GET_SUPABASE_DATA_FAILURE';
export const DATA_CONNECTOR_GET_SUPABASE_DATA_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_SUPABASE_DATA_DISMISS_ERROR';
export const DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_BEGIN =
  'DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_SUCCESS =
  'DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_FAILURE =
  'DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR =
  'DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_BEGIN =
  'DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_BEGIN';
export const DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_SUCCESS =
  'DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_SUCCESS';
export const DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_FAILURE =
  'DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_FAILURE';
export const DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_DISMISS_ERROR =
  'DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_BEGIN =
  'DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_SUCCESS =
  'DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_FAILURE =
  'DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_BEGIN =
  'DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_SUCCESS =
  'DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_FAILURE =
  'DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_SUPABASE_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_BEGIN =
  'DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_BEGIN';
export const DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_SUCCESS =
  'DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_SUCCESS';
export const DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_FAILURE =
  'DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_FAILURE';
export const DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_DISMISS_ERROR =
  'DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_DISMISS_ERROR';

export const DATA_CONNECTOR_XATA_WORKSPACE_LIST_BEGIN = 'DATA_CONNECTOR_XATA_WORKSPACE_LIST_BEGIN';
export const DATA_CONNECTOR_XATA_WORKSPACE_LIST_SUCCESS =
  'DATA_CONNECTOR_XATA_WORKSPACE_LIST_SUCCESS';
export const DATA_CONNECTOR_XATA_WORKSPACE_LIST_FAILURE =
  'DATA_CONNECTOR_XATA_WORKSPACE_LIST_FAILURE';
export const DATA_CONNECTOR_XATA_WORKSPACE_LIST_DISMISS_ERROR =
  'DATA_CONNECTOR_XATA_WORKSPACE_LIST_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_DATABASES_FOR_XATA_BEGIN =
  'DATA_CONNECTOR_GET_DATABASES_FOR_XATA_BEGIN';
export const DATA_CONNECTOR_GET_DATABASES_FOR_XATA_SUCCESS =
  'DATA_CONNECTOR_GET_DATABASES_FOR_XATA_SUCCESS';
export const DATA_CONNECTOR_GET_DATABASES_FOR_XATA_FAILURE =
  'DATA_CONNECTOR_GET_DATABASES_FOR_XATA_FAILURE';
export const DATA_CONNECTOR_GET_DATABASES_FOR_XATA_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_DATABASES_FOR_XATA_DISMISS_ERROR';
export const DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_BEGIN =
  'DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_BEGIN';
export const DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_SUCCESS =
  'DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_SUCCESS';
export const DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_FAILURE =
  'DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_FAILURE';
export const DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_DISMISS_ERROR =
  'DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_BEGIN =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_BEGIN';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_SUCCESS =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_SUCCESS';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_FAILURE =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_FAILURE';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_BEGIN =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_BEGIN';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_SUCCESS =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_SUCCESS';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_FAILURE =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_FAILURE';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_DISMISS_ERROR';

export const DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_BEGIN =
  'DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_BEGIN';
export const DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_SUCCESS =
  'DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_SUCCESS';
export const DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_FAILURE =
  'DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_FAILURE';
export const DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_DISMISS_ERROR';

export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_BEGIN =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_BEGIN';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_SUCCESS =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_SUCCESS';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_FAILURE =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_FAILURE';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_DISMISS_ERROR =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_BEGIN =
  'DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_BEGIN';
export const DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_SUCCESS =
  'DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_SUCCESS';
export const DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_FAILURE =
  'DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_FAILURE';
export const DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_BEGIN =
  'DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_BEGIN';
export const DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_SUCCESS =
  'DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_SUCCESS';
export const DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_FAILURE =
  'DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_FAILURE';
export const DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_COLLECTIONS_FOR_DIRECTUS_DISMISS_ERROR';

export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_BEGIN =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_BEGIN';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_SUCCESS =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_SUCCESS';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_FAILURE =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_FAILURE';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_DISMISS_ERROR =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_BEGIN =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_BEGIN';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_SUCCESS =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_SUCCESS';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_FAILURE =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_FAILURE';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_DISMISS_ERROR';

export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_BEGIN =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_BEGIN';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_SUCCESS =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_SUCCESS';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_FAILURE =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_FAILURE';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_DISMISS_ERROR =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN =
  'DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN';
export const DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS =
  'DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS';
export const DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE =
  'DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE';
export const DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_BEGIN =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_BEGIN';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_SUCCESS =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_SUCCESS';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_FAILURE =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_FAILURE';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_DISMISS_ERROR';
export const DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_BEGIN =
  'DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_BEGIN';
export const DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_SUCCESS =
  'DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_SUCCESS';
export const DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_FAILURE =
  'DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_FAILURE';
export const DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_DISMISS_ERROR =
  'DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_DISMISS_ERROR';

export const DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_BEGIN =
  'DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_BEGIN';
export const DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_SUCCESS =
  'DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_SUCCESS';
export const DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_FAILURE =
  'DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_FAILURE';
export const DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_DISMISS_ERROR =
  'DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_DISMISS_ERROR';

export const DATA_CONNECTOR_AIRTABLE_GET_TABLES_BEGIN = 'DATA_CONNECTOR_AIRTABLE_GET_TABLES_BEGIN';
export const DATA_CONNECTOR_AIRTABLE_GET_TABLES_SUCCESS =
  'DATA_CONNECTOR_AIRTABLE_GET_TABLES_SUCCESS';
export const DATA_CONNECTOR_AIRTABLE_GET_TABLES_FAILURE =
  'DATA_CONNECTOR_AIRTABLE_GET_TABLES_FAILURE';
export const DATA_CONNECTOR_AIRTABLE_GET_TABLES_DISMISS_ERROR =
  'DATA_CONNECTOR_AIRTABLE_GET_TABLES_DISMISS_ERROR';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_BEGIN =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_BEGIN';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_SUCCESS =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_SUCCESS';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_FAILURE =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_FAILURE';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_DISMISS_ERROR =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_AIRTABLE_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_BEGIN =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_BEGIN';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_SUCCESS =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_SUCCESS';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_FAILURE =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_FAILURE';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_AIRTABLE_DISMISS_ERROR';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_BEGIN =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_BEGIN';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_SUCCESS =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_SUCCESS';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_FAILURE =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_FAILURE';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_DISMISS_ERROR =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_DISMISS_ERROR';
export const DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_BEGIN =
  'DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_BEGIN';
export const DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_SUCCESS =
  'DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_SUCCESS';
export const DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_FAILURE =
  'DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_FAILURE';
export const DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR =
  'DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_BEGIN =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_BEGIN';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_SUCCESS =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_SUCCESS';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_FAILURE =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_FAILURE';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_XANO_INSTANCE_BEGIN = 'DATA_CONNECTOR_GET_XANO_INSTANCE_BEGIN';
export const DATA_CONNECTOR_GET_XANO_INSTANCE_SUCCESS = 'DATA_CONNECTOR_GET_XANO_INSTANCE_SUCCESS';
export const DATA_CONNECTOR_GET_XANO_INSTANCE_FAILURE = 'DATA_CONNECTOR_GET_XANO_INSTANCE_FAILURE';
export const DATA_CONNECTOR_GET_XANO_INSTANCE_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_XANO_INSTANCE_DISMISS_ERROR';
export const DATA_CONNECTOR_XANO_TOKEN_URL_BEGIN = 'DATA_CONNECTOR_XANO_TOKEN_URL_BEGIN';
export const DATA_CONNECTOR_XANO_TOKEN_URL_SUCCESS = 'DATA_CONNECTOR_XANO_TOKEN_URL_SUCCESS';
export const DATA_CONNECTOR_XANO_TOKEN_URL_FAILURE = 'DATA_CONNECTOR_XANO_TOKEN_URL_FAILURE';
export const DATA_CONNECTOR_XANO_TOKEN_URL_DISMISS_ERROR =
  'DATA_CONNECTOR_XANO_TOKEN_URL_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_XANO_API_GROUPS_BEGIN = 'DATA_CONNECTOR_GET_XANO_API_GROUPS_BEGIN';
export const DATA_CONNECTOR_GET_XANO_API_GROUPS_SUCCESS =
  'DATA_CONNECTOR_GET_XANO_API_GROUPS_SUCCESS';
export const DATA_CONNECTOR_GET_XANO_API_GROUPS_FAILURE =
  'DATA_CONNECTOR_GET_XANO_API_GROUPS_FAILURE';
export const DATA_CONNECTOR_GET_XANO_API_GROUPS_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_XANO_API_GROUPS_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_BEGIN =
  'DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_BEGIN';
export const DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_SUCCESS =
  'DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_SUCCESS';
export const DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_FAILURE =
  'DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_FAILURE';
export const DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_COLLECTIONS_FOR_SALESFORCE_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_BEGIN =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_BEGIN';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_SUCCESS =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_SUCCESS';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_FAILURE =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_FAILURE';
export const DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_BEGIN =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_BEGIN';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_SUCCESS =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_SUCCESS';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_FAILURE =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_FAILURE';
export const DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_SCHEMA_FOR_SALESFORCE_COLLECTION_DISMISS_ERROR';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_BEGIN =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_BEGIN';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_SUCCESS =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_SUCCESS';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_FAILURE =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_FAILURE';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_DISMISS_ERROR =
  'DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_DISMISS_ERROR';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE';
export const DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR =
  'DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN =
  'DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN';
export const DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS =
  'DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS';
export const DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE =
  'DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE';
export const DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_BEGIN =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_BEGIN';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_SUCCESS =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_SUCCESS';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_FAILURE =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_FAILURE';
export const DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_COLLECTION_FOR_SALESFORCE_DISMISS_ERROR';

export const DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_BEGIN =
  'DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_BEGIN';
export const DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_SUCCESS =
  'DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_SUCCESS';
export const DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_FAILURE =
  'DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_FAILURE';
export const DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_BEGIN =
  'DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_BEGIN';
export const DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_SUCCESS =
  'DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_SUCCESS';
export const DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_FAILURE =
  'DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_FAILURE';
export const DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_DISMISS_ERROR';
export const DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_BEGIN =
  'DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_SUCCESS =
  'DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_FAILURE =
  'DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_DISMISS_ERROR =
  'DATA_CONNECTOR_LOAD_EXTERNAL_APIS_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_BEGIN =
  'DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_BEGIN';
export const DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_SUCCESS =
  'DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_SUCCESS';
export const DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_FAILURE =
  'DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_FAILURE';
export const DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_DISMISS_ERROR';
export const DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_BEGIN =
  'DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_BEGIN';
export const DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_SUCCESS =
  'DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_SUCCESS';
export const DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_FAILURE =
  'DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_FAILURE';
export const DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_DISMISS_ERROR =
  'DATA_CONNECTOR_SUPABASE_ENVIRONMENT_VARIABLES_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_BEGIN =
  'DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_BEGIN';
export const DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_SUCCESS =
  'DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_SUCCESS';
export const DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_FAILURE =
  'DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_FAILURE';
export const DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_APPWRITE_DISMISS_ERROR';
export const DATA_CONNECTOR_APPWRITE_ENVIRONMENT_BEGIN =
  'DATA_CONNECTOR_APPWRITE_ENVIRONMENT_BEGIN';
export const DATA_CONNECTOR_APPWRITE_ENVIRONMENT_SUCCESS =
  'DATA_CONNECTOR_APPWRITE_ENVIRONMENT_SUCCESS';
export const DATA_CONNECTOR_APPWRITE_ENVIRONMENT_FAILURE =
  'DATA_CONNECTOR_APPWRITE_ENVIRONMENT_FAILURE';
export const DATA_CONNECTOR_APPWRITE_ENVIRONMENT_DISMISS_ERROR =
  'DATA_CONNECTOR_APPWRITE_ENVIRONMENT_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_BEGIN =
  'DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_BEGIN';
export const DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_SUCCESS =
  'DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_SUCCESS';
export const DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_FAILURE =
  'DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_FAILURE';
export const DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_DISMISS_ERROR =
  'DATA_CONNECTOR_UPDATE_DIRECTUS_TABLES_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_BEGIN =
  'DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_SUCCESS =
  'DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_FAILURE =
  'DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_BEGIN =
  'DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_BEGIN';
export const DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_SUCCESS =
  'DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_SUCCESS';
export const DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_FAILURE =
  'DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_FAILURE';
export const DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_DISMISS_ERROR =
  'DATA_CONNECTOR_CREATE_ENVIRONMENT_VARIABLES_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_PERMISSION_FLAGS_BEGIN =
  'DATA_CONNECTOR_GET_PERMISSION_FLAGS_BEGIN';
export const DATA_CONNECTOR_GET_PERMISSION_FLAGS_SUCCESS =
  'DATA_CONNECTOR_GET_PERMISSION_FLAGS_SUCCESS';
export const DATA_CONNECTOR_GET_PERMISSION_FLAGS_FAILURE =
  'DATA_CONNECTOR_GET_PERMISSION_FLAGS_FAILURE';
export const DATA_CONNECTOR_GET_PERMISSION_FLAGS_DISMISS_ERROR =
  'DATA_CONNECTOR_GET_PERMISSION_FLAGS_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_BEGIN = 'DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_BEGIN';
export const DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_SUCCESS = 'DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_SUCCESS';
export const DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_FAILURE = 'DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_FAILURE';
export const DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_DISMISS_ERROR = 'DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_DISMISS_ERROR';
export const DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_BEGIN = 'DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_SUCCESS = 'DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_FAILURE = 'DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_DISMISS_ERROR = 'DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_BEGIN = 'DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_SUCCESS = 'DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_FAILURE = 'DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_DISMISS_ERROR = 'DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_BEGIN = 'DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_BEGIN';
export const DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SUCCESS = 'DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SUCCESS';
export const DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_FAILURE = 'DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_FAILURE';
export const DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_DISMISS_ERROR = 'DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_DISMISS_ERROR';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_BEGIN = 'DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_BEGIN';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_SUCCESS = 'DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_SUCCESS';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_FAILURE = 'DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_FAILURE';
export const DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR = 'DATA_CONNECTOR_CREATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR';
export const DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_BEGIN = 'DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_BEGIN';
export const DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_SUCCESS = 'DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_SUCCESS';
export const DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_FAILURE = 'DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_FAILURE';
export const DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR = 'DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR';
export const DATA_CONNECTOR_OPEN_EXTERNAL_DB_SETTING_MODAL = 'DATA_CONNECTOR_OPEN_EXTERNAL_DB_SETTING_MODAL';
export const DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_BEGIN = 'DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_BEGIN';
export const DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_SUCCESS = 'DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_SUCCESS';
export const DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_FAILURE = 'DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_FAILURE';
export const DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_DISMISS_ERROR = 'DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_DISMISS_ERROR';
export const DATA_CONNECTOR_MAP_COLLECTION_WITH_MY_SQL_BEGIN = 'DATA_CONNECTOR_MAP_COLLECTION_WITH_MY_SQL_BEGIN';
export const DATA_CONNECTOR_MAP_COLLECTION_WITH_MY_SQL_SUCCESS = 'DATA_CONNECTOR_MAP_COLLECTION_WITH_MY_SQL_SUCCESS';
export const DATA_CONNECTOR_MAP_COLLECTION_WITH_MY_SQL_FAILURE = 'DATA_CONNECTOR_MAP_COLLECTION_WITH_MY_SQL_FAILURE';
export const DATA_CONNECTOR_MAP_COLLECTION_WITH_MY_SQL_DISMISS_ERROR = 'DATA_CONNECTOR_MAP_COLLECTION_WITH_MY_SQL_DISMISS_ERROR';
export const DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_BEGIN = 'DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_BEGIN';
export const DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_SUCCESS = 'DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_SUCCESS';
export const DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_FAILURE = 'DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_FAILURE';
export const DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_DISMISS_ERROR = 'DATA_CONNECTOR_GET_MY_SQL_TABLE_SCHEMA_DISMISS_ERROR';
export const DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_BEGIN = 'DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_BEGIN';
export const DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_SUCCESS = 'DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_SUCCESS';
export const DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_FAILURE = 'DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_FAILURE';
export const DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_DISMISS_ERROR = 'DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_DISMISS_ERROR';